import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_PARTNER_GET_LISTING_LEAD_OUTCOMES } from 'api/actionTypes';

export default async function getListingLeadOutcomes(
  { state, apiClient },
  { listingId, forceRefresh },
) {
  typeCheck('listingId::PositiveNumber', listingId);

  const partnerListingLeadOutcomes = ['partners', 'listingLeadOutcomes', listingId];
  if (state.get(partnerListingLeadOutcomes) && !forceRefresh) {
    return state.get(partnerListingLeadOutcomes);
  }

  return apiClient.postWithState({
    action: SR_API_ACTION_PARTNER_GET_LISTING_LEAD_OUTCOMES,
    queryId: listingId,
    state: state,
    payload: {
      listingId: listingId,
    },
    onSuccess(result) {
      state.set(partnerListingLeadOutcomes, result);
    },
  });
}
